import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { DocumentFilingPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string | readonly string[],
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) throw new Error(`Document filing page ${exportName} was not found`)
  return { Component: createPermissionGuardedPage(perm, Page, { mode: 'any', administratorBypass: true }) }
}

export const documentFilingRoutes: RouteObject[] = [
  {
    path: 'documents/outstanding',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/document-filing-outstanding-page'),
        'DocumentFilingOutstandingPage',
        DocumentFilingPermissions.submit,
      ),
  },
  {
    path: 'documents/outstanding/:filingId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/document-filing-work-pages'),
        'DocumentFilingWorkPage',
        DocumentFilingPermissions.submit,
      ),
  },
  {
    path: 'admin/document-filing',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/document-filing-admin-pages'),
        'DocumentFilingAssignPage',
        DocumentFilingPermissions.manage,
      ),
  },
  {
    path: 'admin/document-filing/review',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/document-filing-review-pages'),
        'DocumentFilingReviewPage',
        DocumentFilingPermissions.review,
      ),
  },
  {
    path: 'admin/document-filing/review/:filingId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/document-filing-review-pages'),
        'DocumentFilingReviewDetailPage',
        DocumentFilingPermissions.review,
      ),
  },
]
